import axios from "axios";
import { alertError } from "./Alerts";
import { baseUrl } from "../shared";


export const requestPatch = async (serviceName, formData) => {
    try {
        // Validar parámetros
        if (!serviceName) throw new Error("Service name is missing");
        if (!formData) throw new Error("Form data is missing");

        // Configurar headers de autorización
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${token}`
        };

        // Obtener y verificar token de autenticación
        const token = JSON.parse(localStorage.getItem('user_store_ecommerce'));
        if (!token) {
            headers.Authorization = '';
        } else {
            headers.Authorization = `Bearer ${token}`;
        }

        // Realizar la petición PUT con axios
        const responsePut = await axios.patch(baseUrl.concat(serviceName), formData, { headers });

        // Verificar respuesta y retornar datos o lanzar error
        if (responsePut.data === '0') {
            throw new Error("Unexpected response: '0'");
        }

        // Si el token ha expirado, redirigir a la página de inicio de sesión
        // if (responsePut.data === 'Token has expired') {
        //     alertError('Sesión expirada', 'Por favor, inicia sesión de nuevo');
        //     window.location.href = '/login';
        // }
        
        return responsePut.data;

    } catch (error) {
        if (error.response) {
            // Errores del servidor (HTTP)
            // console.error(`HTTP Error ${error.response.status}: ${error.response.statusText}`);
            console.error("Response data:", error.response.data);

            // Si el token ha expirado, redirigir a la página de inicio de sesión
            if (error.response.status === 400 && error.response.data.error === 'El token es inválido o ha expirado') {
                localStorage.removeItem('user_store_ecommerce');
                alertError("Sesión expirada", "Por favor, inicia sesión de nuevo");
                window.location.href = '/my-account';
            }
            // alertError(`Error ${error.response.status}: ${error.response.statusText}`);
            throw new Error(`Request failed with status ${error.response.status}`);
        } else if (error.request) {
            // Errores de red (sin respuesta del servidor)
            console.error("Network error: No response received");
            alertError("Error de red: Por favor, verifica tu conexión");
            throw new Error("Network error: Please check your connection");
        }   
    }
}